<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Spettacoli', route: '/backoffice/spettacoli/' }, { label: 'Personale Area Compagnia Spettacolo', active: true }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">PERSONALE AREA COMPAGNIA SPETTACOLO</h1>
</section>

<section class="px-container">     
    <div class="flex flex-col gap-8">     
        <p class="uppercase text-xl">PERSONALE</p>
        <app-personale-accrediti-backoffice [visione]="true" [personale]="personale || []" [evento]="evento" *ngIf="personale.length > 0" />                                           
    </div>    
</section>

<app-loading-backoffice [visible]="loading"></app-loading-backoffice>